export const AWS_CONFIG = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID as string,
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID as string,
  LoginRedirectUri: process.env.REACT_APP_COGNITO_LOGIN_REDIRECT_URI as string,
  LogoutRedirectUri: process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI as string,
  CognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN as string,
}

export const AZURE_CONFIG = {
  ClientId: process.env.REACT_APP_AZURE_CLIENT_ID as string,
  TenantId: process.env.REACT_APP_AZURE_TENANT_ID as string,
  LoginRedirectUri: process.env.REACT_APP_AZURE_LOGIN_REDIRECT_URI as string,
  LogoutRedirectUri: process.env.REACT_APP_AZURE_LOGOUT_REDIRECT_URI as string,
}

export const APP_CONFIG = {
  Platform: process.env.REACT_APP_PLATFORM as string,
}

export const API_ENDPOINT = process.env.REACT_APP_API_GATEWAY_URL

export const CUSTOMER_ROLE_MAPPING: Record<string, string> = {
  default: 'provider',
  // 'fake-cus-id': 'user',
}
